import { PureComponent } from "react";

import { Link } from "@livechat/design-system-icons";
import { Button, Icon, SpacingToken, Tooltip } from "@livechat/design-system-react-components";

import { CopyToClipboard } from "components/copy-to-clipboard-input";
import Flex from "components/layout/Flex";
import Text from "components/layout/Text";
import { getAppRootWithOrigin } from "helpers/url";
import { withVar } from "themes/helpers";

interface IProps {
  id: string;
  onTicketUrlCopied(): void;
}

export class TicketDetailsInfoTicketId extends PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { id, onTicketUrlCopied } = this.props;
    const ticketUrl = `${getAppRootWithOrigin()}/tickets/${id}`;

    return (
      <Flex inline alignItems="center" gap={withVar(SpacingToken.Spacing1)} data-testid="ticket-id">
        {`${id} `}
        <CopyToClipboard value={ticketUrl} onCopiedHandler={onTicketUrlCopied}>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {({ handleCopy }: any) => (
            <Tooltip
              triggerRenderer={() => (
                <Button
                  size="xcompact"
                  kind="link-light"
                  onClick={handleCopy}
                  icon={<Icon data-testid="copy-ticketid-icon" source={Link} />}
                />
              )}
              kind="invert"
              placement="top"
            >
              <Text fontSize="15px" lineHeight="22px">
                Copy ticket URL
              </Text>
            </Tooltip>
          )}
        </CopyToClipboard>
      </Flex>
    );
  }
}
